'use client';

import { Stack, Typography } from '@mui/material';
import Image from 'next/image';

import { backgrounds } from '@/assets/materials';
import HexagonalButton from '@/components/bases/HexagonalButton';

export const TakeControlSection = () => {
  const openAdminPage = () => {
    window.open(process.env.NEXT_PUBLIC_ADMIN_URL, '_blank');
  };

  return (
    <Stack
      width={'100%'}
      height={'100%'}
      flexGrow={1}
      minHeight={{ xs: '720px', md: '800px' }}
      paddingX={{ xs: '24px', md: '80px' }}
      paddingTop={{ xs: '32px', md: '198px' }}
      paddingBottom={{ xs: '32px', md: '262px' }}
      alignItems={'center'}
      component={'section'}
      position={'relative'}
      sx={{
        background: 'linear-gradient(107.15deg, #252B3C 0%, #05050D 100%)',
        overflow: 'hidden', // Ensures the app image doesn't overflow
      }}>
      {/* Top accent bar */}
      <Stack
        bgcolor={'#060912'}
        className={'bottom-cut'}
        position={'absolute'}
        top={0}
        zIndex={1}
        left={'50%'}
        height={{ xs: '12px', md: '30px' }}
        width={{ xs: 'min(160px, 100%)', md: 'min(616px, 100%)' }}
        sx={{ transform: 'translateX(-50%)' }}
      />

      {/* Background splash image */}
      <Stack zIndex={2} position={'absolute'} top={0} left={0} right={0} bottom={0}>
        <Image priority src={backgrounds.subtract_2_splash} alt={'splash'} layout={'fill'} objectFit={'cover'} />
      </Stack>

      {/* Main content container */}
      <Stack
        width={'100%'}
        maxWidth={'1280px'}
        direction={{ xs: 'column', md: 'row' }}
        justifyContent={'space-between'}
        alignItems={{ xs: 'center', md: 'flex-start' }}
        zIndex={3}
        position={'relative'}>
        {/* Left side content (text and button) */}
        <Stack gap={{ xs: 3, md: 7 }} width={'100%'} maxWidth={'629px'} zIndex={3}>
          <Stack gap={3} width={'100%'}>
            <Typography
              component={'h2'}
              variant={'displayMedium'}
              className={'clip-text'}
              fontSize={{ xs: '24px', md: '48px' }}
              lineHeight={{ xs: '32px', md: '68px' }}
              sx={{ background: 'linear-gradient(90deg, #A9A9A9 0%, #FFFFFF 50%, #A9A9A9 100%)' }}>
              READY TO TAKE CONTROL?
            </Typography>
            <Typography
              component={'h4'}
              variant={'bodyLarge'}
              color={'#FFFFFF'}
              fontSize={{ xs: '14px', md: '18px' }}
              className={'mix-blend'}>
              LFG Core Launchpad puts the power back in your hands. No red tape. No delays. Just rapid, decentralized
              fundraising built for the future of Web3.
            </Typography>
          </Stack>
          <Stack width={'269px'} display={{ xs: 'none', md: 'block' }}>
            <HexagonalButton variant={'secondary'} label={'LAUNCH YOURS NOW'} onClick={openAdminPage} />
          </Stack>
          <Stack width={'198px'} display={{ xs: 'block', md: 'none' }}>
            <HexagonalButton variant={'secondary'} size={'small'} label={'LAUNCH YOURS NOW'} onClick={openAdminPage} />
          </Stack>
        </Stack>

        {/* Right side app UI image */}
        <Stack
          position={{ xs: 'relative', md: 'absolute' }}
          right={{ md: 0 }}
          top={{ md: '-110px' }}
          width={{ xs: '100%', md: '50%', lg: '45%' }}
          mt={{ xs: 6, md: 0 }}
          alignSelf={{ xs: 'center', md: 'flex-end' }}
          zIndex={2}>
          <Image
            priority
            src={backgrounds.hero_admin_browser}
            alt='LFG Core Launchpad Interface'
            width={800}
            height={600}
            className={'w-[520px] h-[380px] sm:w-[800px] sm:h-[600px] object-contain'}
          />
        </Stack>
      </Stack>
    </Stack>
  );
};
